import { withInstall } from '@hd-front-end/utils'
import Rate from './src/rate.vue'

import type { SFCWithInstall } from '@hd-front-end/utils'

export const ElRate: SFCWithInstall<typeof Rate> = withInstall(Rate)
export default ElRate

export * from './src/rate'
